import React from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Route, Switch, Redirect} from "react-router";
import { Helmet } from 'react-helmet'

import SearchModal from '../Search/SearchModal'
import { StripeProvider } from 'react-stripe-elements';

import Auth from './Auth';
import NotFound from './NotFound';
import Header from '../Header/HeaderContainer';
import Home from '../Home/HomeContainer';
import SignIn from '../User/SignIn/SignInContainer';
import SignUp from '../User/SignUp/SignUpContainer';
import MyPage from '../User/MyPage/MyPageContainer';
// import InfoNotice from '../parts/Notice';
import NewCommunity from '../Community/New/NewContainer';
import EditCommunity from '../Community/Edit/EditContainer';
import ShowCommunity from '../Community/Show/ShowContainer';
import ManageCommunity from '../Community/Manage/ManageContainer'
import PreviewCommunity from '../Community/Preview/PreviewContainer'
import FirstProfRegist from '../User/FirstProfRegist/FirstProfRegistContainer';
import JoinedCommunity from '../User/CircleList/CircleListContainer';
import UserMessages from '../User/Messages/MessagesContainer';
import MessageRoom from '../User/MessageRoom/MessageRoomContainer';
import UserProfileEdit from '../User/ProfileEdit/ProfileEditContainer';
import CreditEdit from '../User/Credit/CreditContainer';
import LoadingGif from '../../lib/images/loading.gif';
import GoogleCallback from '../User/SignIn/googleCallback'
import TwitterCallback from '../User/SignIn/twitterCallback'
import FacebookCallback from '../User/SignIn/facebookCallback'
import Terms from '../StaticPages/Terms/Terms'
import PrivacyPolicy from '../StaticPages/PrivacyPolicy/Policy'
import Inquiry from '../Inquiry/InquiryContainer'
import Company from '../StaticPages/Company/Company'
import BankEdit from '../User/Bank/BankContainer'
import SearchResult from '../Search/SearchContainer'
import Post from '../Post/PostContainer'
import Notification from '../User/Notification/NotificationContainer'
import UserShow from '../User/Show/ShowContainer'

import * as RT from '../../constants/Routing';
import * as SG from '../../constants/AppSettings'

import {
} from "react-router-redux";
// import { signInCheck } from '../../actions/App';
import Slideout from 'slideout';
import '../../lib/stylesheets/slideout.css'

const ConnectedSwitch = connect(state => ({
  location: state.router.location
}))(Switch)

// class App extends Component {
export default class Component extends React.Component {

  constructor() {
    super();
    this.state = {
      stripe: null
    }
  }

  checkUnLoad = () => {
    return(
      this.props.App.signInChekLoaded === false && this.props.App.signOuted === false
      // true
    )
  }

  signOut = () => {
    this.props.userSignOut()
  }

  noticeRemove = () => {
    this.props.noticeRemove()
  }

  windowSizeFetch = () => {
    if (!this.checkUnLoad()) {
      const windowHeight = window.innerHeight
      let windowHeightPx;
      if (windowHeight > document.querySelector('#panel .wrap').scrollHeight + 40) {
        windowHeightPx = `${windowHeight + 40}px`
        document.body.style.height = windowHeightPx
        document.querySelector('#root').style.height = windowHeightPx
        document.querySelector('.App').style.height = windowHeightPx
        document.querySelector('#panel').style.height = windowHeightPx
      } else {
        windowHeightPx = `auto`
        document.body.style.height = windowHeightPx
        document.querySelector('#root').style.height = windowHeightPx
        document.querySelector('.App').style.height = windowHeightPx
        document.querySelector('#panel').style.height = windowHeightPx
      }
    }  
  }

  addSlideMenuEvent = () => {
      this.props.jsLoad()
      var slideout = new Slideout({
        'panel': document.getElementById('panel'),
        'menu': document.getElementById('menu'),
        'padding': 256,
        'tolerance': 70
      });

      // Toggle button
      document.querySelector('.toggle-button').addEventListener('click', function () {
        slideout.toggle();
      });
    
    function closeSlide(eve) {
      eve.preventDefault();
      slideout.close();
    }
    
      document.querySelector('.side-menu-close-btn').addEventListener('click', closeSlide)

    var fixed = document.querySelector('header');
    var fixedFooter = document.getElementById('fixedBottomWrap');
    // var fixedMsg = document.getElementById('msgBox')
    var fixedSearch = document.getElementById('searchModal')

    slideout.on('translate', function (translated) {
      fixed.style.transform = 'translateX(' + translated + 'px)';
      fixedFooter.style.transform = 'translateX(' + translated + 'px)';
      fixedSearch.style.transform = 'translateX(' + translated + 'px)';
    });

    slideout.on('beforeopen', function () {
      fixed.style.transition = 'transform 300ms ease';
      fixed.style.transform = 'translateX(256px)';
      fixed.classList.add('panel-open');
      fixedFooter.style.transition = 'transform 300ms ease';
      fixedFooter.style.transform = 'translateX(256px)';
      fixedFooter.classList.add('panel-open');
      fixedSearch.style.transition = 'transform 300ms ease';
      fixedSearch.style.transform = 'translateX(256px)';
      // fixed.classList.add('panel');
      fixedSearch.classList.add('panel-open');
    });

    slideout.on('beforeclose', function () {
      fixed.style.transition = 'transform 300ms ease';
      fixed.style.transform = 'translateX(0px)';
      // fixed.classList.remove('panel');
      fixed.classList.remove('panel-open');
      fixedFooter.style.transition = 'transform 300ms ease';
      fixedFooter.style.transform = 'translateX(0px)';
      // fixed.classList.remove('panel');
      fixedFooter.classList.remove('panel-open');
      fixedSearch.style.transition = 'transform 300ms ease';
      fixedSearch.style.transform = 'translateX(0px)';
      fixedSearch.classList.remove('panel-open');
    });

    slideout.on('open', function () {
      fixed.style.transition = '';
      fixed.addEventListener('click', closeSlide );
      fixedFooter.style.transition = '';
      fixedFooter.addEventListener('click', closeSlide);
      fixedSearch.style.transition = '';
      fixedSearch.addEventListener('click', closeSlide);
    });

    slideout.on('close', function () {
      fixed.style.transition = '';
      fixed.removeEventListener('click', closeSlide);
      fixedFooter.style.transition = '';
      fixedFooter.removeEventListener('click', closeSlide);
      fixedSearch.style.transition = '';
      fixedSearch.removeEventListener('click', closeSlide);
    });

    slideout
      .on('beforeopen', function () {
        this.panel.classList.add('panel-open');
      })
      .on('open', function () {
        this.panel.addEventListener('click', closeSlide);
      })
      .on('beforeclose', function () {
        this.panel.classList.remove('panel-open');
        this.panel.removeEventListener('click', closeSlide);
      });
    }

  componentWillMount = () => {
    this.props.signInCheck()
    if (this.props.App.currentUser && localStorage.getItem('token')) {
      this.props.notificationUnreadGet()
    }
  }

  componentWillUpdate = (nextProps, nextState) => {
    const searchModal = document.getElementById('searchModal')
    if (searchModal.classList.contains("slideIn")) {
      searchModal.classList.remove('slideIn')

      const toggleBtn = document.querySelector('.searchToggleBtn')
      toggleBtn.classList.remove('active')
      document.documentElement.classList.remove('overflow-hidden')
      document.body.classList.remove('overflow-hidden')
      if (toggleBtn.innerText === 'search') {
        toggleBtn.innerText = 'close'
      } else {
        toggleBtn.innerText = 'search'
      }
    }

    if (nextProps.App.signOuted) {
      this.props.noticeAdd('ログアウトしました', 'warning')
      this.props.signOutReset()
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (localStorage.getItem('token') && nextProps.App.currentUser) {
      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.props.notificationUnreadGet()
      }
    }

  }

  shouldComponentUpdate = (nextProps) => {
    let bool = true
    
    if ((this.props.App.infoMsg !== null && this.props.App.infoMsgType !== null) && (nextProps.App.infoMsg === null && nextProps.App.infoMsgType === null)) {
      bool = false
    } else {
      bool = true
    }
    return bool
  }
  
  componentDidMount = () => {
    const searchModal = document.getElementById('searchModal')
    setTimeout(() => {
      searchModal.style.zIndex = 99
    }, 1000);
   
    this.windowSizeFetch()

    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(SG.STRIPE_API_PUBLISH_KEY)})
    } else {
      document.getElementById('stripe-js').addEventListener('load', () => {
        this.setState({ stripe: window.Stripe(SG.STRIPE_API_PUBLISH_KEY)})
      })
    }
  }

  componentDidUpdate = () => {
    if (!this.checkUnLoad() && this.props.App.jsLoaded === false) {
      this.props.jsLoad()
      this.addSlideMenuEvent()
    }

    this.closeMenu()
    this.windowSizeFetch()
  }
  

  closeMenu = () => {
    document.querySelector('.side-menu-close-btn').click()
  }

  render() {
    // const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname
  
      // let infoMsgComponent = null
      // if (this.props.App.infoMsg !== null) {
      //   // infoMsgComponent = null
      //   infoMsgComponent = (
      //     <InfoNotice infoMsgType={this.props.App.infoMsgType} infoMsg={this.props.App.infoMsg} noticeHide={this.noticeRemove} />
      //   )
      // }

      let navMenus = ''
      let appStyle = 'App'

      if (this.props.App.signInCheckResult) {
        navMenus = (
          <nav id="menu">
            <ul>
              <li className="menu-head">
                ログイン中
              </li>
              <li className="">
                <Link to={RT.USER_MYPAGE_PATH}>マイページ</Link>
              </li>
              <li className={!!this.props.App.unreadNotificationCount ? 'hasNotice' : ''}>
                <Link to={RT.USER_NOTIFICATION_PATH}>
                  {(() => {
                    if (!!this.props.App.unreadNotificationCount) {
                      return (
                        <i className="unreadNotice material-icons">notifications_active</i>
                      )
                    } else {
                      return (
                        <i className="material-icons">notifications</i>
                      )
                    }
                  })()}
                  お知らせ
                  {(() => {
                    if (!!this.props.App.unreadNotificationCount) {
                      return (
                        <span className='noticeCount'>({this.props.App.unreadNotificationCount})</span>
                      )
                    }
                  })()}
                </Link>
              </li>
              <li className="">
                <Link to={RT.INQUIRY_PATH}>お問い合わせ</Link>
              </li>
              <li className="">
                <Link to={RT.TERM_PATH}>利用規約</Link>
              </li>
              <li>
                <Link to={RT.PRIVACY_POLICY_PATH}>プライバシーポリシー</Link>
              </li>
              <li className="">
                <Link to={RT.COMPANY_PATH}>会社概要</Link>
              </li>
              <li className="">
                <a className="" onClick={this.signOut}>ログアウト</a>
              </li>
              <li><span className='btn btn-default menu-close-btn' onClick={() => this.closeMenu()} >
                <i className="material-icons">clear</i>閉じる</span>
              </li>
            </ul>
          </nav>
        )
        appStyle += ' user-signed-in'
      } else {
        navMenus = (
          <nav id="menu">
            <ul>
              <li className="menu-head">
                <Link to={RT.ROOT_PATH} className="">Circrew トップへ</Link>
              </li>
              <li className="">
                <Link to={RT.SIGN_IN_PATH} className="">ログイン</Link>
              </li>
              <li className="">
                <Link to={RT.SIGN_UP_PATH} className="">新規登録</Link>
              </li>
              <li className="">
                <Link to={RT.INQUIRY_PATH}>お問い合わせ</Link>
              </li>
              <li className="">
                <Link to={RT.TERM_PATH}>利用規約</Link>
              </li>
              <li>
                <Link to={RT.PRIVACY_POLICY_PATH}>プライバシーポリシー</Link>
              </li>
              <li className="">
                <Link to={RT.COMPANY_PATH}>会社概要</Link>
              </li>
              <li><span className='btn btn-default menu-close-btn' onClick={() => this.closeMenu()} >
                <i className="material-icons">clear</i>閉じる</span>
              </li>
            </ul>
          </nav>
        )
      }
    
    let nowLoading = ''
    if (this.props.App.nowLoading) {
      nowLoading = (
        <div className='now-loading'>
          <div>
            <img src={LoadingGif} alt='' />
          </div>
        </div>
      )
    }

    const metaInfo = (
      <Helmet>
        <title>{SG.META_TITLE}</title>
        <meta name='description' content={SG.META_DESCRIPTION} />
      </Helmet>
    )
    
      return (
        <StripeProvider stripe={this.state.stripe}>
          <div className={appStyle}>
            {metaInfo}
            {navMenus}
            {nowLoading}
            {/* <div id='msgBox'>
              {infoMsgComponent}
            </div> */}
            <Header unReadNotification={!!this.props.App.unreadNotificationCount}/>
            
            <div id='dialogSpace'></div>
            <main id="panel" className='panel' >
              <div className='wrap'>
                {(() => {
                  if (this.checkUnLoad()) {
                    return (
                      <div className='loading-gif'>
                        <img src={LoadingGif} alt='' />
                      </div>
                    )
                  } else {
                    return (
                      <ConnectedSwitch>
                        {(() => {
                          if (this.props.App.afterUserCreate && this.props.App.currentUser && localStorage.getItem('token') && currentPath !== RT.USER_FIRST_PROF_PATH) {
                            return (
                              <Redirect to={RT.USER_FIRST_PROF_PATH} />
                            )
                          }
                        })()}
                        <Route exact path={RT.ROOT_PATH} component={Home} />
                        <Route exact path={RT.SIGN_UP_PATH} component={SignUp} />
                        <Route exact path={RT.SIGN_IN_PATH} component={SignIn} />
                        <Route exact path={RT.GOOGLE_CALLBACK_PATH} component={GoogleCallback} />
                        <Route exact path={RT.TWITTER_CALLBACK_PATH} component={TwitterCallback} />
                        <Route exact path={RT.FACEBOOK_CALLBACK_PATH} component={FacebookCallback} />
                        <Route exact path={RT.TERM_PATH} component={Terms} />
                        <Route exact path={RT.PRIVACY_POLICY_PATH} component={PrivacyPolicy} />
                        <Route exact path={RT.INQUIRY_PATH} component={Inquiry} />
                        <Route exact path={RT.COMPANY_PATH} component={Company} />
                        <Route exact path={RT.COMMUNITY_PATH} component={ShowCommunity} />
                        <Route exact path={RT.SEARCH_RESULT_PATH} component={SearchResult} />
                        <Route exact path={RT.USER_SHOW_PATH} component={UserShow} />
                        <Auth currentUser={this.props.App.currentUser} currentPath={currentPath}>
                          <Switch>
                            <Route exact path={RT.USER_FIRST_PROF_PATH} component={FirstProfRegist} />
                            <Route exact path={RT.USER_MYPAGE_PATH} component={MyPage} />
                            <Route exact path={RT.COMMUNITY_NEW_PATH} component={NewCommunity} />
                            <Route exact path={RT.USER_JOINED_COMMUNITIES_PATH} component={JoinedCommunity} />
                            <Route exact path={RT.USER_MESSAGES_PATH} component={UserMessages} />
                            <Route exact path={RT.USER_EDIT_PATH} component={UserProfileEdit} />
                            <Route exact path={RT.USER_CREDIT_EDIT_PATH} component={CreditEdit} />
                            <Route exact path={RT.COMMUNITY_EDIT_PATH} component={EditCommunity} />
                            <Route exact path={RT.COMMUNITY_PREVIEW_PATH} component={PreviewCommunity} />
                            <Route exact path={RT.USER_BANK_EDIT_PATH} component={BankEdit} />
                            <Route exact path={RT.COMMUNITY_POSTS_PATH} component={Post} />
                            <Route exact path={RT.USER_NOTIFICATION_PATH} component={Notification} />
                            <Route exact path={RT.MESSAGE_ROOM_PATH} component={MessageRoom} />
                            <Route exact path={RT.COMMUNITY_MANAGE_PATH} component={ManageCommunity} />
                            <Route component={NotFound} states={404} />
                          </Switch>
                        </Auth>
                        <Route component={NotFound} states={404} />
                      </ConnectedSwitch>
                    )
                  }
                })()}
              </div>
              <div id='contentOverlayWrap'></div>
            </main>
            <div id='fixedBottomWrap' className='panel'></div>
            <SearchModal />
            <div id='menuBottomWrap'></div>
          </div>
        </StripeProvider>
      );
    // }
  }
}

// function mapStateToProps(state) {
//   return {state}
// }

// export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App/App.jsx